var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPandasOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#130754",
    d: "M46.236 7.567h13.99v29.047h-13.99Zm0 59.668h13.99V96.28h-13.99Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffca00",
    d: "M46.236 45.092h13.99v13.705h-13.99Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#130754",
    d: "M23.763 31.446h13.989V128h-13.99ZM68.245 91.2h13.99v29.046h-13.99Zm0-59.72h13.99v29.047h-13.99Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e70488",
    d: "M68.245 69.011h13.99v13.705h-13.99Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#130754",
    d: "M90.248 0h13.99v96.554h-13.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandasOriginal);
export default __webpack_public_path__ + "static/media/pandas-original.8f75ffe747f823efc5af786c76fdb7a2.svg";
export { ForwardRef as ReactComponent };